import {ModuleProto} from "../module-proto"
import {ModuleType} from "../types"
import {SettingsMenuTopCategory} from "../settings-module"
import {SettingsParentSection} from "../../../app/settings/const"

// const debug = "GoalsModule"
const debug = false

export class GoalsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.GOALS, moduleConfig)

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Goals"
        this.description                = "The Goals module empowers users with a comprehensive toolset to set, manage, and track project objectives efficiently. From defining clear goals to monitoring progress in real-time, this module fosters collaboration and alignment within teams."
        this.svgIcon                    = "isvg-goals"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Productivity & Collaboration"
        this.settingsUrl                = "settings/goals"

        this.parentSection              = SettingsParentSection.PRODUCTIVITY
    }

    enable():void {
        super.enable()

        // gd.layout.left?.reRender()
        gd.layout.navigation.reset()
        gd.layout.navigation.reRender()
    }

    disable():void {
        super.disable()

        // gd.layout.left?.reRender()
        gd.layout.navigation.reset()
        gd.layout.navigation.reRender()
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}